export const spaceAboveHeader = 16;
export const headerHeight = 64;
export const spaceBelowHeader = 12;
export const bottomNavigation = 80;
